import styled from "styled-components";
import { Variables } from "../../styles/Variables";

// Contenedor principal
export const BodyContainer = styled.main`
  display: flex;
  justify-content: space-evenly;
  background-image: url("/backgroundStart.png");
  background-repeat: no-repeat;
  background-size: cover;
  margin-bottom: 40px;

  @media (max-width: ${Variables.maxTablet}) {
    flex-direction: column;
  }
`;

export const ContainerLeft = styled.div`
  width: 60%;
  padding-bottom: 40px;

  @media (max-width: ${Variables.maxTablet}) {
    margin: 0 auto;
    width: 90%;
  }
`;

export const ContainerRight = styled.div`
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
  width: 38%;
  min-height: 90vh;

  @media (max-width: ${Variables.maxTablet}) {
    margin: 0 auto;
    width: 60%;
  }

  @media (max-width: ${Variables.maxMobile}) {
    padding: 20px 5%;
    width: 100%;
    background-color: #c2c4cb;
  }
`;

export const TextInterest = styled.p`
  font-size: 35px;
  font-weight: 600;
  color: ${Variables.colorBlackDark};
`;

export const Content = styled.main`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const AnimationLoading = styled.div`
  display: inline-block;
  align-self: center;
  width: 80px;
  height: 80px;

  & :after {
    content: " ";
    display: block;
    margin: 8px;
    width: 64px;
    height: 64px;
    border: 6px solid ${Variables.colorPrimary};
    border-radius: 50%;
    border-color: ${Variables.colorPrimary} transparent ${Variables.colorPrimary} transparent;
    animation: lds-dual-ring 1.2s linear infinite;
  }

  @keyframes lds-dual-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const ContainerLinks = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 93%;
`;

export const ContainerPagination = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  width: 90%;
  height: 3%;
`;

export const ContainerButton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #2959fb;
  cursor: pointer;

  :hover {
    color: #072fb8;
    text-decoration: underline;
  }
`;

// Título principal
export const Title = styled.p`
  text-align: center;
  font-size: 70px;
  font-weight: 600;
  color: ${Variables.colorBlackDark};
  margin: 40px 40px;

  @media (max-width: 1440px) {
    margin: 20px 10px;
    font-size: 65px;
  }

  @media (max-width: 1366px) {
    margin: 10px 10px;
    font-size: 45px;
  }

  @media (max-width: ${Variables.maxMobile}) {
    margin: 30px 5px;
    font-size: 29px;
  }
`;

export const WhiteLetter = styled.span`
  color: ${Variables.colorWhite};
`;

export const OrangeLetter = styled.span`
  color: ${Variables.colorOrange};
`;

// Contenedor de opciones
export const OptionsContainer = styled.div`
  margin-left: 20%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px;
  width: 60%;

  @media (max-width: 1440px) {
    margin: 0 auto;
    width: 70%;
  }

  @media (max-width: 1024px) {
    margin: 0 auto;
    width: 90%;
  }

  @media (max-width: ${Variables.maxMobile}) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const TemasSection = styled.div`
  margin-top: -1000px;
  margin-left: 1000px;
  display: flex;
  padding: 20px 40px;
`;
